
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StoreFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Store"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gateway"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"installDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"installerNotes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isActive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAtmosphereEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isDhcp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isExpectWifi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isFillerEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isHighPriority"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isInstalled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isInstallerWifiTest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isProgrammatic"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPassiveProgrammatic"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSendSCReports"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSpanishEmails"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSpanishEmailsRetailer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lat"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lng"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"networkPrefixLength"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"networkSecurityType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"wpaEnterpriseUsername"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"psk"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"wpaePassword"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scFrequency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ssid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tz"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uninstallDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zip"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"opsManagerId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAssignedOver72Hours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"storeClusterId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"internetType"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":587}};
    doc.loc.source = {"body":"fragment StoreFields on Store {\n  address\n  city\n  gateway\n  hours\n  id\n  installDate\n  installerNotes\n  isActive\n  isAtmosphereEnabled\n  isDhcp\n  isExpectWifi\n  isFillerEnabled\n  isHighPriority\n  isInstalled\n  isInstallerWifiTest\n  isProgrammatic\n  isPassiveProgrammatic\n  isSendSCReports\n  isSpanishEmails\n  isSpanishEmailsRetailer\n  lat\n  lng\n  name\n  networkPrefixLength\n  networkSecurityType\n  wpaEnterpriseUsername\n  notes\n  phone\n  psk\n  wpaePassword\n  scFrequency\n  ssid\n  state\n  tz\n  uninstallDate\n  zip\n  opsManagerId\n  isAssignedOver72Hours\n  storeClusterId\n  internetType\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["StoreFields"] = oneQuery(doc, "StoreFields");
        



//////////////////
// WEBPACK FOOTER
// ./src/graphql/store/StoreFieldsFragment.gql
// module id = tm8I
// module chunks = 87